import { useAxios } from "@/lib/hooks";

import { getUserIdentity } from "./user";

export const useUserApi = () => {
  const { axiosInstance } = useAxios();

  return {
    getUserIdentity: async () => getUserIdentity(axiosInstance),
  };
};
